export default __webpack_public_path__ + "static/media/react-js.764b1e3c.svg";